export default __webpack_public_path__ + "static/media/Rectangle.3e3abb71.svg";